import { AUTOSCORE } from "@/constants/applications";
import { subApplicants } from "@/data/sub-applicant-data";
import React from "react";

const SubApplicantsDetailCard = () => {
  return (
    <div>
      <h6 className="text-muted mb-3">Other Applicants</h6>
      <div className="card custom-card overflow-hidden  mb">
        <div className="card-body p-0">
          {subApplicants.map((a, x) => (
            <SubApplicantRow {...a} key={x} />
          ))}
        </div>
      </div>
    </div>
  );
};

const SubApplicantRow = ({ first_name, last_name, screening_type }) => (
  <div className="d-sm-flex align-items-top p-4 border-bottom border-block-end-dashed c-pointer">
    <div>
      <div className="avatar avatar-md bg-primary avatar-rounded me-3">AA</div>
    </div>
    <div className="flex-fill main-profile-info">
      <h6 className="fw-semibold mb-0">{`${first_name} ${last_name}`}</h6>
      <div className="fs-14 text-muted">{screening_type}</div>
    </div>
    <div>
      <span className={`badge bg-${AUTOSCORE["pass"].variant}-transparent`}>
        {AUTOSCORE["pass"].label}
      </span>
    </div>
  </div>
);

SubApplicantsDetailCard.propTypes = {};

export default SubApplicantsDetailCard;
